<template>
<v-app id="inspire">
        <v-navigation-drawer v-model="drawer" app fixed color="#fff" style="max-width:250;">
        <v-list-item tow-line color="#000">
            <v-list-item-avatar rounded size="40" color="#fff">
                <v-img src="https://ik.imagekit.io/trainway/avatar.webp?updatedAt=1750180707305"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-subtitle style="color:#000;">
                    <span v-if="name != null">Hello! {{name}}</span>
                    <span v-else>Hello! Welcome</span>
                </v-list-item-subtitle>
                <v-list-item-subtitle style="color:#000;">
                    <span v-if="email != null">{{email}}</span>
                    <span v-else>Guest</span>
                </v-list-item-subtitle>
            </v-list-item-content>

        </v-list-item>

        <v-divider></v-divider>
        <v-list nav dense>
            <v-subheader>
                Users & Company Profile
            </v-subheader>

            <v-list-item to="/myaccount">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-contacts-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>My Account</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/more">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-home-import-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>More</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>
           <v-subheader>
                Other Service
            </v-subheader>
            <v-list-item to="/group-order">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Group Order</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

         <v-list-item to="/restaurant-signup">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-card-account-details</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Vendor Registration</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/track-order">
                <v-list-item-icon>
                    <v-icon color="#000">mdi-shopping-search</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Track Order</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>

            <v-subheader>Contact Info </v-subheader>

            <v-list-item class="contactinfo">
                <v-list-item-content>
                    <v-list-item-title tag="a" href="tel:+91 88099-52644">
                        <v-icon>mdi-phone-classic</v-icon> +91 88099-52644
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://api.whatsapp.com/send?phone=918809952644" target="_blank">
                        <v-icon>mdi-whatsapp</v-icon> +91 88099-52644
                    </v-list-item-title>
                    <!-- <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                        <v-icon>mdi-email-outline</v-icon> support@trainway.co.in
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://www.facebook.com/profile.php?id=61550849225493/" target="_blank">
                        <v-icon>mdi-facebook</v-icon> Follow us on Facebook
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://in.pinterest.com/trainway/" target="_blank">
                        <v-icon>mdi-pinterest</v-icon> Follow us on Twitter
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://www.instagram.com/trainwaay/" target="_blank">
                        <v-icon>mdi-instagram</v-icon> Follow us on Instagram
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="https://www.youtube.com/@trainwaay/
" target="_blank">
                        <v-icon>mdi-youtube</v-icon> Follow us on YouTube
                    </v-list-item-title> -->

                </v-list-item-content>
            </v-list-item>

            <!-- <v-subheader>
             Download the App
            </v-subheader>

            <v-list-item>
                <v-list-item-content class="contactinfo">
                    <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                    <v-img src="/images/gplay.webp"></v-img>
                    </v-list-item-title>
                    <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                     <v-img src="/images/appstore.webp"></v-img>
                    </v-list-item-title>
            </v-list-item-content>
            </v-list-item> -->

        </v-list>
    </v-navigation-drawer>

     <v-app-bar app elevation="0" color="#05445E" dark fixed top>

            <v-container class="fill-height d-flex d-sm-none align-center py-0 px-0">
                <v-app-bar-nav-icon @click="drawersidebar" style="color: #ffffff; margin-left: -19px;"
                    class="d-block d-sm-none"></v-app-bar-nav-icon>
                    <v-img src="https://ik.imagekit.io/trainway/trainway.webp?updatedAt=1750180725826" max-width="130"></v-img>
                <v-spacer></v-spacer>
                <v-btn href="tel:+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
                   <v-icon>mdi-cellphone-basic</v-icon>
               </v-btn>
               <v-btn href="whatsapp://send?text=trainway=+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
               <v-icon>mdi-whatsapp</v-icon>
             </v-btn>
            </v-container>

            <v-container class="fill-height d-none d-sm-flex align-center">
                <router-link to="/"> <v-img src="https://ik.imagekit.io/trainway/trainway.webp?updatedAt=1750180725826" max-width="130"></v-img>  </router-link>
                <v-spacer></v-spacer>
                <v-btn to="/" elevation="0" color="#ffffff" text>HOME</v-btn>
                <v-btn to="/check-pnr-status" elevation="0" color="#ffffff" text>PNR STATUS</v-btn>
                <v-btn to="/train-running-status" elevation="0" color="#ffffff" text>RUNNING STATUS</v-btn>
                <v-btn to="/seat-availability" elevation="0" color="#ffffff" text>SEAT AVAILABILITY</v-btn>
                <v-btn to="/train-between-stations" elevation="0" color="#ffffff" text>TRAIN BETWEEN STATION</v-btn>
                <v-btn to="/login" elevation="0" color="#ffffff" text>TRACK ORDER</v-btn>
                <v-btn href="tel:+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 30px">
        <v-icon>mdi-cellphone-basic</v-icon>  </v-btn>
        <v-btn href="whatsapp://send?text=trainway=+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 30px">
        <v-icon>mdi-whatsapp</v-icon> </v-btn>
        </v-container>
    </v-app-bar>
    <v-main>
        <v-container>
            <v-row>
                <v-col cols="12" md="12">
                <p class="d-flex" style="font-size:14px;">
                        Choose Delivery Station
                        <v-spacer></v-spacer>
                        {{outletFilter.length}} Stations
                    </p>
                    <v-card v-for="station in outletFilter" :key="station.code" class="mb-3" elevation="0" outlined>

                        <v-card-text class="text--primary" @click="viewstrore(station.code)">
                            <p class="font-weight-bold p d-flex mb-0" style="font-size: 15px;">
                                {{ station.name }} [{{ station.code }}]
                                <v-spacer></v-spacer>
                                <span style="color:green">{{station.arrival}}</span>
                            </p>
                            <p class="d-flex mb-0">
                                Halt - {{ station.halt }}
                                Delay - {{ station.delayArrival }}
                                <v-spacer></v-spacer>
                                <span>{{station.arrDate}}</span>
                            </p>
                            <p class="d-flex mb-0">
                                <span class="font-weight-bold">{{ station.store.length }} Restaurant.
                                    Min. Order: <v-icon style=" font-size: 14px; margin-right: -1px;">mdi-currency-inr</v-icon>{{Math.floor(Math.random() * (120 - 70)) + 70}}
                                </span>
                            </p>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-main>


    <v-overlay :opacity="0.5" :value="overlay" color="rgb(243, 203, 174)">
        <v-progress-circular indeterminate size="64">
            Loading...
        </v-progress-circular>
    </v-overlay>


</v-app>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.metaTitle,
            htmlAttrs: {
                lang: "en-US",
            },
            meta: [

                { name: "description", content: this.metaDesc,},
                { name: "keywords", content: this.metaKeyword,},
                { name: "author", content: 'trainway'},
                { name: "robots", content: 'index, follow',},

                { name: "twitter:card", content: 'summary_large_image',},
                { name: "twitter:title", content: this.metaTitle,},
                { name: "twitter:description", content: this.metaDesc,},
                { name: "twitter:image", content: this.image,},
                { name: "twitter:site", content: '@trainway',},


                { property: "og:title", content: this.metaTitle,},
                { property: "og:description", content: this.metaDesc,},
                { property: "og:image", content: this.image,},
                { property: "og:url", content: this.siteUrl,},
                { property: "og:type", content: 'website',},
                { property: "og:site_name", content: 'trainway',},


            ],
            link: [{
                rel: "canonical",
                href: this.siteUrl,
            }, ],
        }
    },
    data: () => ({
        metaTitle: undefined,
        metaDesc: undefined,
        metaKeyword: undefined,
        image: undefined,
        siteUrl: undefined,
        content: "",

        overlay: true,
        drawer: false,
        pnrInput: null,
        outletFilter: [],
        trainName: null,
        trainNo: null,

        overlay: true,
        sheet: false,
        drawer: false,

    }),
    methods: {
        outletsRetrive() {
            const outlets = JSON.parse(localStorage.getItem('outlets')) || null;

            var phoneno = /^\d{10}$/;
            if (outlets == null) {
                if (this.$route.params.bytrainorpnr.match(phoneno)) {
                    axios.get(`/api/outletbypnr/` + this.$route.params.bytrainorpnr).then((response) => {
                        if (response.data) {
                            localStorage.setItem('outlets', JSON.stringify(response.data));
                            this.outletFilter = response.data;
                            this.trainName = response.data[0].traininfo.name;
                            this.trainNo = response.data[0].traininfo.trainNo;

                            this.metaTitle = `ORDER FOOD ON TRAIN ${response.data[0].traininfo.name}`;
                            this.metaDesc = `We provide a variety of quality food (breakfast, meals, dinner) veg & non-veg food in trains ${response.data[0].traininfo.name} `;
                            this.metaKeyword = `food on train ${response.data[0].traininfo.name}, irctc food order ${response.data[0].traininfo.name}`;
                            this.siteUrl = `https://www.trainway.in/outlets/${response.data[0].traininfo.trainNo}`;
                            this.image = "IMAGE";
                        }
                    })
                } else {
                    axios.get(`/api/outletbytrain/` + this.$route.params.bytrainorpnr).then((response) => {
                        if (response.data) {
                            localStorage.setItem('outlets', JSON.stringify(response.data));
                            this.outletFilter = response.data;
                            this.trainName = response.data[0].traininfo.name;
                            this.trainNo = response.data[0].traininfo.trainNo;

                            this.metaTitle = `ORDER FOOD ON TRAIN ${response.data[0].traininfo.name}`;
                            this.metaDesc = `We provide a variety of quality food (breakfast, meals, dinner) veg & non-veg food in trains ${response.data[0].traininfo.name} `;
                            this.metaKeyword = `food on train ${response.data[0].traininfo.name}, food delivery in train ${response.data[0].traininfo.name}`;
                            this.siteUrl = `https://www.trainway.in/outlets/${response.data[0].traininfo.trainNo}`;
                            this.image = "IMAGE";
                        }
                    })
                }
            } else {
                this.outletFilter = outlets;
                this.trainName = outlets[0].traininfo.name;
                this.trainNo = outlets[0].traininfo.trainNo;

                this.metaTitle = `ORDER FOOD ON TRAIN ${outlets[0].traininfo.name}`;
                this.metaDesc = `We provide a variety of quality food (breakfast, meals, dinner) veg & non-veg food in trains ${outlets[0].traininfo.name} `;
                this.metaKeyword = `food on train ${outlets[0].traininfo.name}, food delivery in train ${outlets[0].traininfo.name}`;
                this.siteUrl = `https://www.trainway.in/outlets/${outlets[0].traininfo.trainNo}`;
                this.image = "IMAGE";
            }

        },
        viewstrore: function (stationcode) {
            this.outletFilter.filter((value, key) => {
                if (value.code == stationcode) {
                    localStorage.setItem('orderstation', JSON.stringify(this.outletFilter[key]));
                    this.$router.push('/station/order-food-in-train-at-' + stationcode);
                }
            })
        },

    },
    mounted() {
        this.outletsRetrive();
    },
    created(){
        setTimeout(() => {
            this.overlay = false
        }, 1000)
    }

}
</script>

<style>

.imagewrap .theme--light.v-image{position: relative; height: 120px;}
.imagewrap .v-image__image--cover{width: 100%; height: 100%; object-fit: contain;}

.contactinfo .v-image.v-responsive.theme--light .v-image__image.v-image__image--cover{width: 100%; height: 100%; object-fit: contain;}
.contactinfo .imagewrap .v-image__image--cover{width: 100%; height: 100%; object-fit: contain;}

.v-navigation-drawer__content{background: #f0ffff;}
#inspire .v-list-item__icon{margin-right: 10px;}

.contactinfo .v-list-item__title{margin-bottom: 8px; color: rgba(0,0,0,.87); text-decoration: none;}
.contactinfo .v-list-item__title i{margin: 0px 6px 6px 0px;}

.bannersearcbox {
  padding: 120px 0;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  margin-bottom: 15px;
}

.bannersearcbox .v-input.v-input--hide-details {
  background-color: #fff;
}

@media (max-width: 767px) {
  .bannersearcbox {
    padding: 0;
    background-repeat: no-repeat !important;
    background-size: 100% !important;
    margin-bottom: 0;
    background: #fff !important;
  }
}

.p-12 {
    color: #444;
    font-size: 12px !important;
}

.p-14 {
    font-size: 14px !important;
}

.step {
    max-width: 50px;
    max-height: 50px;
}

 @media (max-width: 767px) {
        .hidden-mobile {
          display: none;
        }
      }
</style>
